<template>
	<!-- tab 时间 -->
	<div>
		<div class="buttonBox" style="margin-bottom: 10px;">
			<div>
				<div class="chooseButton searchButton" @click="addFactory($t('btn_14'))" v-if="MenuRoleList.indexOf('4')>=0">
					<i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
				</div>
				<div class="chooseButton searchButton" @click="addFactory($t('btn_15'))">
					<i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
				</div>
				<div class="chooseButton deleteButton" @click="factoryDel"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
			</div>
		</div>
		<div class="tableList">
			<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDatadialog" highlight-current-row
				@current-change="handleCurrentChangeTree" height="500" style="width: 880px;margin: 5px;overflow: auto;"
				:header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">

				<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex"
					width="50">
				</el-table-column>
				<el-table-column prop="personnel" label="开始时间" align="center">
				</el-table-column>
				<el-table-column  prop="finishTime" label="结束时间" align="center">
					<template slot-scope="scope">
						{{scope.row.finishTime}}
						<el-checkbox v-if="scope.row.isNextDay==1">次日</el-checkbox>
					</template>
				</el-table-column>
				<el-table-column prop="itemNum" label="时长(分)" align="center">
				</el-table-column>
				<el-table-column prop="time" label="人员" align="center">
				</el-table-column>
			</el-table>
			<div style="position: absolute;bottom: 30px;left: 30%">
				<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
					:currentspage="1" @parentMethod="searchPage"></Page>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import popMesBox from "@/components/list/popover/pop";
	import inspectionEquipment from "@/components/list/displayPage/inspectionEquipment";
	import inspectionProject from "@/components/list/displayPage/inspectionProject";
	import inspectionTime from "@/components/list/displayPage/inspectionTime";


	export default {
		name: 'inspectionTime',
		components: {
			Page,
			calendar,
			exportMes,
			popMesBox,
			inspectionEquipment,
			inspectionProject,
			inspectionTime,
		},
		data() {
			return {
				pageNum: 1,
				select: 0,
				pageSize: 8,
				pageCount: 0,
				Readytime: '',
				height: 620,
				MenuRoleList: [],
				dialogFactoryEdit: {
					code: "",
					name: "",
					maker: "",
					model: "",
					saler: "",
					price: "",
					type: this.defaultType,
					unit: this.defaultUnit,
					warningInventory: "",
					warningTime: "",
					remark: "",
				},
				tableDatadialog: [{
					personnel: '08:10',
					finishTime: '08:20',
					itemNum: '10',
					time: '张三',
					isNextDay: 0,
				},{
					personnel: '23:40',
					finishTime: '00:10',
					itemNum: '30',
					time: '李四',
					isNextDay: 1,
				}],
				cardData: [],
				tableDataTreeInfo: {}, //页面数据
				factoryDialogTitle: this.$t('btn_14'), //弹出框的标题
				getTreeMes: '1',
				dialogFactory: false, //弹出框的当前状态
				searchDataList: {
					list: [],
					name: '',
					language: 'zh',
				},
				tableDataTreeTime: [],
				tableDataTreeTimeExport: [], //页面导出的数据
				tableDataTree: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				factoryTypeList: [],
			}
		},
		methods: {
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize
				}
				this.searchPage(param);
			},
			//分页查询
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				console.log(dataParam)
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				// this.getPartsinformation(newParam);
			},

			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			selectProp: function(index) {
				console.log(index)
				this.select = index
			},
			//单选
			handleChange(selection) {
				this.delelist = []
				this.delelist = selection
			},

			//点击编辑选中的数据
			addFactory(title) {
				this.factoryDialogTitle = title;
				if (title != this.$t('btn_14')) {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						this.dialogFactory = true;
						this.dialogFactoryEdit = this.tableDataTreeInfo;
						file.saveEquipmentPartsInfoByid(this.tableDataTreeInfo.id).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.dialogFactory = true;
								this.dialogFactoryEdit = data.data
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else {
					this.dialogFactory = true;
				}
			},
			//弹框关闭再打开清空的方法
			handleClose() {
				this.dialogFactory = false;
			},


			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			// handleCurrentChangeTreeTime(info) {},
			// handleClickSpot(tab, event) {

			// },



			//点击删除按钮
			factoryDel() {
				let param = this.tableDataTreeInfo.id;
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning',
					}).then(() => {
						file.delEquipmentParts(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.search();
								this.$message({
									message: '删除成功',
									type: 'success'
								});
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			}
		},

		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			// this.getPartsinformation({
			// 	"pageNum": 1,
			// 	"pageSize": 8,
			// })
			this.search()
		}

	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/inspectionTime.vue